import { Injectable } from '@angular/core';
import { Subject, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventsService {

  private channels = new Map<string, Subject<any>>();

  /**
   * Equivalent to events.publish('event-name', data)
   */
  publish(eventName: string, data?: any): void {
    if (!this.channels.has(eventName)) {
      this.channels.set(eventName, new Subject<any>());
    }
    this.channels.get(eventName)!.next(data);
  }

  /**
   * Equivalent to events.subscribe('event-name', callback)
   */
  subscribe(eventName: string, callback: (data?: any) => void): Subscription {
    if (!this.channels.has(eventName)) {
      this.channels.set(eventName, new Subject<any>());
    }
    return this.channels.get(eventName)!.subscribe(callback);
  }

  /**
   * Equivalent to events.unsubscribe(subscription)
   */
  unsubscribe(subscription: Subscription): void {
    subscription?.unsubscribe();
  }

  /**
   * Optional: remove all listeners of an event
   */
  destroy(eventName: string): void {
    this.channels.get(eventName)?.complete();
    this.channels.delete(eventName);
  }
}
